export const getDeletedMessageSx = (isCurrentUser?: boolean) => ({
  containerSx: {
    background: isCurrentUser ? 'M.70' : 'surface2',
    border: 'none',
    borderRadius: isCurrentUser ? '4px 4px 0px 4px' : '0px 4px 4px 4px',
    p: 2,
    maxWidth: '256px',
    width: '100%',
  },
  textSx: {
    color: 'M.40',
  },
});
